import { useState, useEffect } from "react";
import "./AnalyticsReady.css";

export default function AnalyticsReady() {
  const [current, setCurrent] = useState(0);

  const getVisibleCount = () => {
    if (typeof window !== "undefined") {
      if (window.innerWidth < 576) return 1;
      if (window.innerWidth < 992) return 2;
    }
    return 3;
  };

  const [visibleCount, setVisibleCount] = useState(getVisibleCount);

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleCount());
      setCurrent(0);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cards = [
    {
      title: "Predictive Analytics",
      desc: "We help you anticipate future outcomes by uncovering patterns in your data.",
      items: [
        "Forecast sales trends to optimize inventory and staffing",
        "Predict customer behavior to enhance marketing and service strategies",
        "Identify potential risks before they impact operations",
        "Improve budgeting with accurate cost and revenue forecasts",
      ],
    },
    {
      title: "Performance Analytics",
      desc: "We help you measure success and uncover opportunities for improvement.",
      items: [
        "Track key business metrics and goals in real time",
        "Compare team and departmental performance over time",
        "Identify top performers and replicate success patterns",
        "Monitor project progress and optimize resource utilization",
      ],
    },
    {
      title: "Financial Analytics",
      desc: "We help you make smarter financial decisions with data-driven insights.",
      items: [
        "Analyze spending patterns to identify cost-saving opportunities",
        "Monitor cash flow to maintain healthy working capital",
        "Evaluate profit margins by product, service, or customer segment",
        "Benchmark financial performance against industry standards and competitors",
      ],
    },
    {
      title: "Predictive Analytics",
      desc: "We help you anticipate future outcomes by uncovering patterns in your data.",
      items: [
        "Forecast sales trends to optimize inventory and staffing",
        "Predict customer behavior to enhance marketing and service strategies",
        "Identify potential risks before they impact operations",
        "Improve budgeting with accurate cost and revenue forecasts",
      ],
    },
  ];

  const maxIndex = cards.length - visibleCount;

  const prev = () => setCurrent((c) => Math.max(c - 1, 0));
  const next = () => setCurrent((c) => Math.min(c + 1, maxIndex));

  return (
    <div id="analytics-ready" className="outsourcemainclass">
      <div className="left">
        <h2 className="heading">
          Enterprise-Ready Data & Analytics Powering Real-Time Intelligence
        </h2>
        <p className="subheading">
          Driving intelligent business decisions through advanced analytics
          expertise that transforms complex data into clear, actionable insights
          at scale.
        </p>
      </div>
      <div className="right">
        <div className="carousel-wrapper">
          <div className="cards-viewport">
            <div
              className="cards"
              style={{
                transform: `translateX(calc(-${current} * (100% / ${visibleCount} + 7px)))`,
              }}
            >
              {cards.map((card, i) => (
                <div className="card" key={i}>
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                  <ul>
                    {card.items.map((item, j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
          <div className="carousel-controls">
            <button
              onClick={prev}
              disabled={current === 0}
              className="carousel-btn"
            >
              &#8249;
            </button>
            <button
              onClick={next}
              disabled={current === maxIndex}
              className="carousel-btn"
            >
              &#8250;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}